import { IconPack } from "Benchmarking/Config/Icons";

export const _nav = [
  {
    label: "Faculty",
    key: "faculty",
    to: "faculty/profile",
    svg: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9 20V10C9 8.89543 9.89543 8 11 8H13C14.1046 8 15 8.89543 15 10V20M9 20C9 21.1046 9.89543 22 11 22H13C14.1046 22 15 21.1046 15 20M9 20V14C9 12.8954 8.10457 12 7 12H5C3.89543 12 3 12.8954 3 14V20C3 21.1046 3.89543 22 5 22H7C8.10457 22 9 21.1046 9 20ZM15 20V16C15 14.8954 15.8954 14 17 14H19C20.1046 14 21 14.8954 21 16V20C21 21.1046 20.1046 22 19 22H17C15.8954 22 15 21.1046 15 20Z"
          stroke="black"
          strokeWidth="1.5"
        />
        <path
          d="M11.5245 1.96353C11.6741 1.50287 12.3259 1.50287 12.4755 1.96353L12.6324 2.4463C12.6993 2.65232 12.8913 2.7918 13.1079 2.7918H13.6155C14.0999 2.7918 14.3013 3.4116 13.9094 3.6963L13.4988 3.99468C13.3235 4.122 13.2502 4.34768 13.3171 4.5537L13.474 5.03647C13.6237 5.49713 13.0964 5.88019 12.7046 5.59549L12.2939 5.29712C12.1186 5.1698 11.8814 5.1698 11.7061 5.29712L11.2954 5.59549C10.9036 5.88019 10.3763 5.49713 10.526 5.03647L10.6829 4.5537C10.7498 4.34768 10.6765 4.122 10.5012 3.99468L10.0906 3.6963C9.69871 3.4116 9.90009 2.7918 10.3845 2.7918H10.8921C11.1087 2.7918 11.3007 2.65232 11.3676 2.4463L11.5245 1.96353Z"
          fill="black"
        />
      </svg>
    ),
    svg_fill: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.4755 1.96366C12.3259 1.503 11.6741 1.503 11.5245 1.96366L11.3676 2.44643C11.3007 2.65245 11.1087 2.79193 10.8921 2.79193H10.3845C9.90009 2.79193 9.69871 3.41173 10.0906 3.69643L10.5012 3.99481C10.6765 4.12213 10.7498 4.34781 10.6829 4.55383L10.526 5.0366C10.3763 5.49726 10.9036 5.88032 11.2954 5.59562L11.7061 5.29725C11.8814 5.16993 12.1186 5.16993 12.2939 5.29725L12.7046 5.59562C13.0964 5.88032 13.6237 5.49726 13.474 5.0366L13.3171 4.55383C13.2502 4.34781 13.3235 4.12213 13.4988 3.99481L13.9094 3.69643C14.3013 3.41173 14.0999 2.79193 13.6155 2.79193H13.1079C12.8913 2.79193 12.6993 2.65245 12.6324 2.44643L12.4755 1.96366ZM11 8.00013C9.89543 8.00013 9 8.89556 9 10.0001V20.0001C9 21.1047 9.89543 22.0001 11 22.0001H13C14.1046 22.0001 15 21.1047 15 20.0001V10.0001C15 8.89556 14.1046 8.00013 13 8.00013H11ZM18 14.0001C16.8954 14.0001 16 14.8956 16 16.0001V20.0001C16 21.1047 16.8954 22.0001 18 22.0001H20C21.1046 22.0001 22 21.1047 22 20.0001V16.0001C22 14.8956 21.1046 14.0001 20 14.0001H18ZM2 14.0001C2 12.8956 2.89543 12.0001 4 12.0001H6C7.10457 12.0001 8 12.8956 8 14.0001V20.0001C8 21.1047 7.10457 22.0001 6 22.0001H4C2.89543 22.0001 2 21.1047 2 20.0001V14.0001Z"
          fill="var(--benchmarking-color)"
        />
      </svg>
    ),
  },
  {
    label: "Institution",
    key: "institution",
    to: "institution/profile",
    svg: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9 20V10C9 8.89543 9.89543 8 11 8H13C14.1046 8 15 8.89543 15 10V20M9 20C9 21.1046 9.89543 22 11 22H13C14.1046 22 15 21.1046 15 20M9 20V14C9 12.8954 8.10457 12 7 12H5C3.89543 12 3 12.8954 3 14V20C3 21.1046 3.89543 22 5 22H7C8.10457 22 9 21.1046 9 20ZM15 20V16C15 14.8954 15.8954 14 17 14H19C20.1046 14 21 14.8954 21 16V20C21 21.1046 20.1046 22 19 22H17C15.8954 22 15 21.1046 15 20Z"
          stroke="black"
          strokeWidth="1.5"
        />
        <path
          d="M11.5245 1.96353C11.6741 1.50287 12.3259 1.50287 12.4755 1.96353L12.6324 2.4463C12.6993 2.65232 12.8913 2.7918 13.1079 2.7918H13.6155C14.0999 2.7918 14.3013 3.4116 13.9094 3.6963L13.4988 3.99468C13.3235 4.122 13.2502 4.34768 13.3171 4.5537L13.474 5.03647C13.6237 5.49713 13.0964 5.88019 12.7046 5.59549L12.2939 5.29712C12.1186 5.1698 11.8814 5.1698 11.7061 5.29712L11.2954 5.59549C10.9036 5.88019 10.3763 5.49713 10.526 5.03647L10.6829 4.5537C10.7498 4.34768 10.6765 4.122 10.5012 3.99468L10.0906 3.6963C9.69871 3.4116 9.90009 2.7918 10.3845 2.7918H10.8921C11.1087 2.7918 11.3007 2.65232 11.3676 2.4463L11.5245 1.96353Z"
          fill="black"
        />
      </svg>
    ),
    svg_fill: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.4755 1.96366C12.3259 1.503 11.6741 1.503 11.5245 1.96366L11.3676 2.44643C11.3007 2.65245 11.1087 2.79193 10.8921 2.79193H10.3845C9.90009 2.79193 9.69871 3.41173 10.0906 3.69643L10.5012 3.99481C10.6765 4.12213 10.7498 4.34781 10.6829 4.55383L10.526 5.0366C10.3763 5.49726 10.9036 5.88032 11.2954 5.59562L11.7061 5.29725C11.8814 5.16993 12.1186 5.16993 12.2939 5.29725L12.7046 5.59562C13.0964 5.88032 13.6237 5.49726 13.474 5.0366L13.3171 4.55383C13.2502 4.34781 13.3235 4.12213 13.4988 3.99481L13.9094 3.69643C14.3013 3.41173 14.0999 2.79193 13.6155 2.79193H13.1079C12.8913 2.79193 12.6993 2.65245 12.6324 2.44643L12.4755 1.96366ZM11 8.00013C9.89543 8.00013 9 8.89556 9 10.0001V20.0001C9 21.1047 9.89543 22.0001 11 22.0001H13C14.1046 22.0001 15 21.1047 15 20.0001V10.0001C15 8.89556 14.1046 8.00013 13 8.00013H11ZM18 14.0001C16.8954 14.0001 16 14.8956 16 16.0001V20.0001C16 21.1047 16.8954 22.0001 18 22.0001H20C21.1046 22.0001 22 21.1047 22 20.0001V16.0001C22 14.8956 21.1046 14.0001 20 14.0001H18ZM2 14.0001C2 12.8956 2.89543 12.0001 4 12.0001H6C7.10457 12.0001 8 12.8956 8 14.0001V20.0001C8 21.1047 7.10457 22.0001 6 22.0001H4C2.89543 22.0001 2 21.1047 2 20.0001V14.0001Z"
          fill="var(--benchmarking-color)"
        />
      </svg>
    ),
  },
];
export const _side_nav = [
  {
    label: "Profile",
    key: "profile",
    to: "/profile",
    svg: IconPack.profile,
  },
  {
    label: "Rank",
    key: "rank",
    to: "/rank",
    svg: IconPack.rank,
  },
  {
    label: "Compare",
    key: "compare",
    to: "/compare",
    svg: IconPack.compare,
  },
  {
    label: "Group",
    key: "group",
    to: "/group",
    svg: IconPack.group,
  },
  {
    label: "Comparision",
    key: "comparision",
    to: "/comparision",
    svg: IconPack.saved_comparision,
  },
  {
    label: "Ranking",
    key: "ranking",
    to: "/ranking",
    svg: IconPack.saved_ranking,
  },
];
